import { FeatureApiInstance } from './feature-api.js';

const localStorageKey = (featureKey: string): string => `ents-wishlist-feature-seen-${featureKey}`;

export const featureSeen = {
  isSeen(featureKey: string): boolean {
    return window.localStorage.getItem(localStorageKey(featureKey)) === 'seen';
  },
  markSeen(featureKey: string, opts: { loggedIn: boolean; endpoint: string }): void {
    window.localStorage.setItem(localStorageKey(featureKey), 'seen');
    if (opts.loggedIn) {
      void FeatureApiInstance.markSeen(opts.endpoint, featureKey);
    }
  },
};
